module.exports = __webpack_public_path__ + "static/media/numbers-process.498c0639.svg";